import { Box, Container, Stack, Typography } from "@mui/material";
import React, { useContext } from "react";
import { logo, logoWhite } from "../components/SmallComponents/Images";
import { StyledButton } from "../components/SmallComponents/AppComponents";
import { RiTwitterXFill } from "react-icons/ri";
import { AppContext, serverUrl } from "../utils";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function LogIn() {
  const { setUserLoginStatus } = useContext(AppContext);
  const navigate = useNavigate();

  // const handleLogin = async () => {
  //   try {
  //     const { data } = await axios.get(`${serverUrl}/auth/twitter`);
  //     console.log(data);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };
  return (
    <Box
      sx={{
        display: "flex",
        height: "99vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container>
        <Stack
          sx={{
            borderRadius: "30px",
            boxShadow: "0px 3px 22px 0px #ffffff",
            py: { xs: 10, sm: 10, md: 3, xl: 5, lg: 5 },
            // mt: { xs: 6, sm: 6, md: 1.5, xl: 12, lg: matchesTwo ? 2 : 7 },
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#292929",
          }}
        >
          <Stack
            sx={{
              flexDirection: "column",
              gap: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Stack
              sx={{
                flexDirection: "row",
                gap: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                component={"img"}
                src={logoWhite}
                alt={""}
                width={{ xs: "12%", sm: "10%", md: "7%" }}
              />
              <Typography
                variant="h1"
                sx={{
                  fontFamily: "Saira Semi Condensed",
                  fontSize: { xs: "26px", md: "38px" },
                  fontWeight: "700",
                  letterSpacing: "1px",
                  color: "#ffffff",
                }}
              >
                BITGROK AI
              </Typography>
            </Stack>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Montserrat",
                my: 5,

                mx: { xs: 3, sm: 10, md: 28 },
                textAlign: "center",
                fontSize: { xs: "16px", md: "18px" },
                fontWeight: "400",
                color: "#ffffff",
              }}
            >
              $BGAI is BITGROK AI blockchain native token that rewards
              interaction between our community members & non community members.
              By tweeting you are helping spread the word of $BGAI while in
              return getting rewarded in $BGAI for doing so.
            </Typography>
            <Box>
              <StyledButton
                href={`${serverUrl}/auth/twitter`}
                width={{ xs: "260px", sm: "290px" }}
                startIcon={<RiTwitterXFill />}

                // onClick={() => {
                //   // handleLogin();
                //   setUserLoginStatus(true);
                //   navigate("/feeds");
                // }}
              >
                Continue with Twitter
              </StyledButton>
            </Box>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}

export default LogIn;
